import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstants } from '../../shared/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class MyDocFormattingService {


  constructor(private httpClient: HttpClient) { }

  getMyDocFormattings(includeAll: boolean): Observable<any> {
    return this.httpClient.get(ApiConstants.DocumentMyDocFormattings_Api+"/"+includeAll);
  }
}
